import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { style } from "@vanilla-extract/css";

export const listStyle = style({
  // Don't remove
});

export const listContainerStyle = recipe({
  base: {
    width: "100%",
  },
  variants: {
    variant: {
      default: {},
      primary: {
        gap: theme.spacings.xs,
      },
      secondary: {},
      compact: {},
    },
    size: {
      s: {
        borderRadius: theme.borderRadiuses.xs,
      },
      m: {
        borderRadius: theme.borderRadiuses.s,
      },
      l: {
        borderRadius: theme.borderRadiuses.m,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    size: "l",
  },
});
